import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { ProductOutlined } from '@ant-design/icons';
import cattleRoutes from "./cattles/routes";
import carabaoRoutes from "./carabaos/routes";
import goatRoutes from "./goats/routes";
import sheepRoutes from "./sheeps/routes";
import swineRoutes from "./swines/routes";
import { MODULE_REG_ANIMALS } from "variables/constants";


const registeredAnimalRoutes = [	
	{
		name: "Registered Animals",
		layout: "/console",
		path: "#",    
		component: null,
		isMainMenu:true,
		icon: <ProductOutlined className="h-6 w-6"/>,
		level: 4,
		moduleId: MODULE_REG_ANIMALS,
		children: [
			...cattleRoutes,  
			...goatRoutes,
			...sheepRoutes,
		]
	},
]

export default registeredAnimalRoutes;